import { Box } from 'braid-design-system';
import React from 'react';

import { UserRegistrationType } from 'src/generated/graphql';

import salesCollateralCtaLargeImage from '../resources/sales-collateral-cta--large.jpg';
import salesCollateralCtaSmallImage from '../resources/sales-collateral-cta--small.jpg';

import * as styles from './SalesCollateralCta.css';

interface SalesCollateralCtaProps {
  userRegistrationType: UserRegistrationType;
}

export function SalesCollateralCta(props: SalesCollateralCtaProps) {
  // These types aren't supported by our form
  if (
    props.userRegistrationType === UserRegistrationType.Buyer ||
    props.userRegistrationType === UserRegistrationType.LicensorOrDistributor ||
    props.userRegistrationType === UserRegistrationType.RealEstateAgent
  ) {
    return null;
  }

  let link;
  if (props.userRegistrationType === UserRegistrationType.Broker) {
    link =
      'https://www.seekbusiness.com.au/business-resources/broker-advertising';
  } else if (props.userRegistrationType === UserRegistrationType.Franchisor) {
    link =
      'https://www.seekbusiness.com.au/business-resources/franchise-advertising';
  } else if (
    props.userRegistrationType === UserRegistrationType.PrivateSeller ||
    // "Other" accounts for the "small to medium-sized enterprise (SME)" option
    props.userRegistrationType === UserRegistrationType.Other
  ) {
    link = 'https://www.seekbusiness.com.au/private-seller-info';
  }

  return (
    <Box component="a" href={link}>
      <Box className={styles.mobileImageContainer}>
        <img
          src={salesCollateralCtaSmallImage}
          className={styles.responsiveImage}
          alt="Thinking about advertising?"
        />
      </Box>
      <Box className={styles.desktopImageContainer}>
        <img
          src={salesCollateralCtaLargeImage}
          className={styles.responsiveImage}
          alt="Thinking about advertising? Explore our product offerings and unlock your full potential"
        />
      </Box>
    </Box>
  );
}
